/**
 * AngularJS default filter in ui-select with the following expression:
 * "person in people | filter: {name: $select.search, age: $select.search}"
 * performs a AND between 'name: $select.search' and 'age: $select.search'.
 * We want to perform a OR. The following function achieves that. This has been 
 * refactored from the official ui-select docs https://angular-ui.github.io/ui-select/#examples. 
 */
angular.module('vrm.components').filter('propsFilter', function () {
    
    return function (items, props) {
        if (!Array.isArray(items)) {
            return items; // Return early if items is not an array
        }
    
        return items.filter(item => {
            return Object.keys(props).some(prop => {
                const text = props[prop].toLowerCase();
                const itemValue = item[prop];
    
                // Check if the property exists and is not undefined
                return itemValue !== undefined && itemValue.toString().toLowerCase().includes(text);
            });
        });
    };
});
